export class TelevisionAdvertising {
  public carouselItems: Array<{ title: string; categories: Array<string>, active?: boolean }> = [
    {
      title: 'Traditional advertising Buying',
      categories: [],
      active: true
    }, {
      title: 'Superimposed advertising',
      categories: []
    }, {
      title: 'Integrating with digital elements',
      categories: []
    }
  ];
}